import { useState } from 'react';
import QueueSelector from './QueueSelector';
import MetricSelector from './MetricSelector';
import WidgetPreview from './WidgetPreview';
import ThresholdBuilder from './ThresholdBuilder';
import AlertComponent from '../Common/AlertComponent';
import {
    Tabs,
    TabList, 
    TabPanels, 
    Tab, 
    TabPanel,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    IconButton

  } from '@chakra-ui/react';
  import { EditIcon } from '@chakra-ui/icons';



function EditWidgetModal({queues, ccxQueues, boardData, setBoardData, widget, symbeeStats}) {
    
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [error, setError] = useState(false);
    const [errorDesc,setErrorDesc] = useState({body: null, title: null});
    const [tempWidget, setTempWidget] = useState({...widget});

    const handleSave = async () => {
      console.log(tempWidget)
        if(tempWidget.name.length < 1){
        setErrorDesc({body: 'You must specify a title', title: 'Missing widget parameters'});
        setError(true);
        return;
      }
      // if( boardData.layout.includes(tempWidget.name)){
      //   setErrorDesc({body: 'Widget title must be unique within this boardData', title: 'Naming Conflict'});
      //   setError(true);
      //   return;
      // }
      if(tempWidget.statistic.length < 1){
        setErrorDesc({body: 'You must choose a metric', title: 'Missing widget parameters'});
        setError(true);
        return;
      }
      if(tempWidget.arn.length < 1){
        setErrorDesc({body: 'You must choose at least one queue', title: 'Missing widget parameters'});
        setError(true);
        return;
      }
      if(tempWidget.name.length > 0 && tempWidget.statistic.length > 0 && tempWidget.arn.length > 0){
        setError(false);
      }
      
        let tempBoardData = {...boardData};
        let tempWidgetArray = [...boardData.widgets];
        let tempLayoutArray = [...boardData.layout];
        
        //find the index of this widget in the array and update it
        let indexWidget = tempWidgetArray.findIndex(widgetItem => widgetItem.id === tempWidget.id);
        tempWidgetArray[indexWidget] = tempWidget;
        tempLayoutArray[indexWidget] = tempWidget.id;
        tempBoardData.widgets = tempWidgetArray;
        tempBoardData.layout = tempLayoutArray;
        console.log(tempBoardData);
        setBoardData(tempBoardData);
        // setTempWidget({name: "", arn: [], statistic: [], type: "", thresholds: {}, id: ""});
      return onClose();

    };
    
    const handleDelete = async () => {
      alert('delete');
      return onClose();

    };

    return (
      <>
        <IconButton aria-label='Add Item' icon={<EditIcon />} size='xs' variant='ghost' onClick={onOpen} />
  
        <Modal closeOnOverlayClick={false} size={'xl'} isOpen={isOpen} onClose={onClose} scrollBehavior='inside'>
          <ModalOverlay />
          <ModalContent minWidth='60vw' maxWidth='60vw' minHeight='50vh' >
            <ModalHeader>Build Widget</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
            {error ? <AlertComponent title={errorDesc?.title} body={errorDesc?.body}/> : null }
              <Tabs>
                <TabList>
                  <Tab>Queue Selection</Tab>
                  <Tab>Metric Selection</Tab>
                  <Tab>Thresholds</Tab>
                </TabList>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                  <TabPanels>

                    <TabPanel>
                      <QueueSelector symbeeStats={symbeeStats} queues={queues} ccxQueues={ccxQueues} setTempWidget={setTempWidget} tempWidget={tempWidget}/>
                    </TabPanel>
                    <TabPanel>
                      <MetricSelector symbeeStats={symbeeStats} setTempWidget={setTempWidget} tempWidget={tempWidget} queues={queues} ccxQueues={ccxQueues}/>
                    </TabPanel>
                    <TabPanel>
                      <ThresholdBuilder setTempWidget={setTempWidget} tempWidget={tempWidget}/>
                    </TabPanel>
                  </TabPanels>
                    <WidgetPreview symbeeStats={symbeeStats} setTempWidget={setTempWidget} tempWidget={tempWidget} queues={queues} ccxQueues={ccxQueues} />
                </div>
              </Tabs>
            
            
                
            </ModalBody>
            <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={handleDelete}>
                Delete
              </Button>
              <Button colorScheme='blue' mr={3} onClick={handleSave}>
                Save
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  export default EditWidgetModal;